export default "__VITE_ASSET__1FUx74dG__"